import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from 'contexts/AuthContext';
import toast from 'react-hot-toast';
import { BallTriangle } from 'react-loader-spinner';
import Nodatafound from 'pages/Common/Nodatafound';
import jobServices from 'ApiService/Admin/jobServices';
import studentService from 'ApiService/Teacher/Student';

const ViewJobPost = ({ courseId }) => {
  const [jobs, setJobs] = useState([]);
  const { state } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [selectedJobFeedback, setSelectedJobFeedback] = useState([]);
  const [joabloading, setJobloading] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState('');

  const fetchJobs = async () => {
    try {
      setLoading(true);

      let response;
      if (state.user.role === 'admin' || state.user.role === 'superadmin') {
        response = await jobServices.getAllJobs(courseId);
      } else if (state.user.role === 'teacher') {
        response = await studentService.getAllJobs(courseId);
      }
      if (response.data.success) {
        setJobs(response.data.jobPosts || []);
      } else {
        toast.error('No job listings found.');
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Failed to fetch job listings.'
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchFeedbackForJob = async (jobAssignmentId) => {
    setJobloading(true);
    try {
      let response;
      if (state.user.role === 'admin' || state.user.role === 'superadmin') {
        response = await jobServices.getFeedbackForJob({ jobAssignmentId });
      } else if (state.user.role === 'teacher') {
        response = await studentService.getFeedbackForJob({ jobAssignmentId });
      }
      if (response.data.success) {
        setSelectedJobFeedback(response.data.feedbacks);
        toast.success('Feedback retrieved successfully');
      } else {
        toast.error(response.data.message || 'No feedback found for this job.');
        setSelectedJobFeedback([]);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          'Failed to fetch feedback for this job.'
      );
      setSelectedJobFeedback([]);
    } finally {
      setJobloading(false);
    }
  };

  useEffect(() => {
    if (state?.user && courseId) {
      fetchJobs();
    }
  }, [state?.user, courseId]);

  if (joabloading) {
    return (
      <div className="flex h-64 items-center justify-center rounded border p-4 dark:border-gray-700 dark:bg-navy-800">
        <BallTriangle className="h-8 w-8 animate-spin text-gray-500" />
      </div>
    );
  }

  const renderFeedbackRounds = (rounds) => {
    return rounds.map((round, index) => (
      <div
        key={index}
        className="mb-4 rounded-lg bg-gray-50 p-3 dark:bg-navy-700"
      >
        <h4 className="mb-2 text-base font-semibold">
          Round {round.roundNumber}
        </h4>
        <p className="mb-2">
          <strong>Feedback:</strong> {round.feedback || 'No feedback provided'}
        </p>

        {round.questions && round.questions.length > 0 && (
          <div>
            <h5 className="mb-1 text-sm font-medium">Questions:</h5>
            <ul className="list-disc pl-5">
              {round.questions.map((question, qIndex) => (
                <li key={qIndex} className="text-sm">
                  {question.questionText}
                  <span className="ml-2 text-xs text-gray-500">
                    (Added: {new Date(question.dateAdded).toLocaleString()})
                  </span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    ));
  };

  return (
    <div className="mt-4 h-full w-full rounded-[20px] md:mt-5">
      {loading ? (
        <div className="flex  items-center justify-center">
          <BallTriangle color="#5431ed" />
        </div>
      ) : jobs.length === 0 ? (
        <div className="flex  items-center justify-center dark:text-gray-600">
          <Nodatafound title="No job listings found" />
        </div>
      ) : (
        <div className="w-full">
          <select
            className="mb-4 w-full rounded border border-gray-300 p-2 dark:border-gray-700 dark:bg-navy-800 dark:text-white"
            value={selectedJobId}
            onChange={(e) => {
              const jobId = e.target.value;
              setSelectedJobId(jobId);
              if (jobId) {
                fetchFeedbackForJob(jobId);
              }
            }}
          >
            <option value="">Select a job posting</option>
            {jobs.map((job) => (
              <option key={job._id} value={job._id}>
                {job.industry} - {job.jobTitle}
              </option>
            ))}
          </select>
          {selectedJobFeedback && selectedJobFeedback.length === 0 ? (
            <>
              {' '}
              <div className="flex  items-center justify-center dark:text-gray-600">
                <Nodatafound title="No Feedback listings found" />
              </div>{' '}
            </>
          ) : (
            <>
              {' '}
              {selectedJobFeedback.map((job) => (
                <div className="rounded  border p-4 text-navy-800 dark:border-gray-700 dark:bg-navy-800 dark:text-white">
                  <h2 className="mb-4 text-xl font-bold">Feedback Details</h2>

                  <div className="mb-4 grid grid-cols-1 gap-4 md:grid-cols-2">
                    <div>
                      <p className="font-semibold">Student Information</p>
                      <p>
                        <strong>Name:</strong>{' '}
                        {job.studentId.name || 'User Name'}
                      </p>
                      <p>
                        <strong>Email:</strong>{' '}
                        {job.studentId.email || 'User email'}
                      </p>
                    </div>
                    <div>
                      <p className="font-semibold">Job Assignment Details</p>
                      <p>
                        <strong>Created At:</strong>{' '}
                        {new Date(job.createdAt).toLocaleString() ||
                          'createdAt'}
                      </p>
                      <p>
                        <strong>Last Updated:</strong>{' '}
                        {new Date(job.updatedAt).toLocaleString() ||
                          'updatedAt'}
                      </p>
                    </div>
                  </div>

                  <div>
                    <h3 className="mb-3 text-lg font-semibold">
                      Feedback Rounds
                    </h3>
                    {job.rounds && job.rounds.length > 0 ? (
                      renderFeedbackRounds(job.rounds)
                    ) : (
                      <p>No rounds found for this feedback.</p>
                    )}
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ViewJobPost;
